/**
 * Free shipping insurance is ON by default (2026-10-24).
 * - Cart has products but no insurance line → add it (once per cart).
 * - Customer switches it off → remember for this cart token, never re-add.
 * - Only insurance left in the cart → remove it, so the cart is truly empty.
 * Toggle clicks themselves stay in custom.js; this only listens.
 */
(function () {
  if (window.__tlInsDefault) return;
  window.__tlInsDefault = true;

  var OPTOUT_KEY = "tl_ins_optout_v1";
  var busy = false;
  var lastToken = "";
  var timer = null;

  function insId() {
    var el = document.querySelector("#tl-shipping-protection-form .product-variant-id");
    var id = (el && el.value) || window.shippingProductId || "";
    return String(id || "");
  }

  function root() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    } catch (e) {}
    return "/";
  }

  function getOptout() {
    try {
      return localStorage.getItem(OPTOUT_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function setOptout(token) {
    try {
      if (token) localStorage.setItem(OPTOUT_KEY, token);
      else localStorage.removeItem(OPTOUT_KEY);
    } catch (e) {}
  }

  function fetchCart() {
    return fetch(root() + "cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function post(path, body) {
    return fetch(root() + path, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
  }

  function refresh() {
    if (typeof window.tlRefreshCartDrawerSections === "function") {
      window.tlRefreshCartDrawerSections();
    }
  }

  function ensure() {
    var id = insId();
    if (!id || busy) return;
    busy = true;
    fetchCart()
      .then(function (cart) {
        lastToken = cart.token || "";
        var insLine = null;
        var others = 0;
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) === id) insLine = item;
          else if (item.final_line_price > 0) others += item.quantity;
        });

        // Card is hidden while the auto-add is pending (tl-ins-pending, 2026-10-28); show it when we won't add.
        var optedOut = others > 0 && !insLine && getOptout() === cart.token;
        document.querySelectorAll(".tl-cart-ins-card.tl-ins-pending").forEach(function (el) {
          el.classList.toggle("tl-ins-optout", optedOut);
        });
        if (others > 0 && !insLine && getOptout() !== cart.token) {
          return post("cart/add.js", { items: [{ id: Number(id), quantity: 1 }] }).then(refresh);
        }
        if (others === 0 && insLine) {
          return post("cart/change.js", { id: insLine.key, quantity: 0 }).then(refresh);
        }
      })
      .catch(function () {
        document.querySelectorAll(".tl-cart-ins-card.tl-ins-pending").forEach(function (el) {
          el.classList.add("tl-ins-optout");
        });
      })
      .then(function () {
        setTimeout(function () {
          busy = false;
        }, 400);
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(ensure, 500);
  }

  // Remember the customer's own choice (capture phase: runs before custom.js flips state).
  document.addEventListener(
    "click",
    function (e) {
      var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
      if (!label) return;
      var wasOn = label.classList.contains("checked");
      if (lastToken) setOptout(wasOn ? lastToken : "");
      fetchCart()
        .then(function (cart) {
          setOptout(wasOn ? cart.token : "");
        })
        .catch(function () {});
    },
    true
  );

  ["cart:updated", "cart:refresh", "cart-drawer:update", "cart-drawer:render"].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  try {
    var host = document.querySelector("cart-drawer") || document.body;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  } catch (e) {}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule);
  else schedule();
})();
